import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

//internal import
import UserServices from "../services/UserServices";
import { notifyError, notifySuccess } from "../utils/toast"; 
import { allContext } from "../context/AllContext"; 

const useUserSubmit = (id) => { 
  const [viewData, setviewData] = useState([]);  
  const [isModal, setIsModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [status, setStatus] = useState("Active");
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const { dataUpdate, setDataUpdate } = useContext(allContext);
  const [privilegesave, setprivilegesave] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();


  const onSubmit = async (userData) => {
    try {
      userData.status = status; 
         
      if (id) { 
        const res = await UserServices.updateUsers(id, userData);
        notifySuccess(res.message);
        setIsModal(false); 
        setDataUpdate(!dataUpdate); 
        const result = await UserServices.updateModulePermission({"module":privilegesave, "id":res?.userId});
        notifySuccess(result.message); 
      } else {
        const res = await UserServices.addUsers(userData);
        notifySuccess(res.message); 
        setIsModal(false); 
        setDataUpdate(!dataUpdate);
        const result = await UserServices.updateModulePermission({"module":privilegesave, "id":res?.userId});
        notifySuccess(result.message); 
      } 
      
      return; 
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };  

  const deleteUser = async (userID) => {
      const result = await UserServices.deleteUsers(userID);
      notifySuccess(result?.message); 
      setDataUpdate(!dataUpdate);
      setIsDeleteModal(false);
  }  

  const ShowEditValues = async (row, type) => { 
    
    const result = await UserServices.getUsersById(row._id);
    if(type === "Edit") {
      setValue("name", result?.user?.name);
      setValue("username", result?.user?.username);
      setValue("email", result?.user?.email);
      setValue("password", result?.user?.password);
      setValue("phone", result?.user?.phone); 
      setValue("address", result?.user?.address);
      setValue("dob", result?.user?.dob);  
      setValue("doj", result?.user?.joiningDate);
      setValue("departmentId", result?.user?.departmentId?._id);
      setValue("status", result?.user?.status); 

      const res = await UserServices.getUserModulesById(result?.user?._id);
      setprivilegesave(res?.module)
    }else {
      setviewData(result?.user);
    }
  }

  useEffect(() => { 
    if(!id) {
      setValue("name", ""); 
      setValue("username", ""); 
      setValue("email", "");
      setValue("password", "");   
      setValue("phone", "");
      setValue("address", "");
      setValue("dob", ""); 
      setValue("doj", ""); 
      setValue("department", "");
      setValue("status", "");
      setStatus("Active");
    }
  }, [id])
 
  return {
    register,
    handleSubmit,
    onSubmit, 
    errors,
    setviewData,
    viewData,
    deleteUser,
    isModal, setIsModal, 
    ShowEditValues,
    isViewModal, setIsViewModal,
    status, setStatus,
    isDeleteModal, setIsDeleteModal,
    privilegesave, setprivilegesave, setDataUpdate, dataUpdate
  };
};

export default useUserSubmit;
